<template>
  <v-tab-item>
    <v-card>
      <v-card-text>
        <v-tabs v-model="activeTab">
          <v-tab>Activator</v-tab>
          <v-tab>Popup Content</v-tab>
          <v-tab>Actions/Links</v-tab>
        </v-tabs>
        <v-tabs-items v-model="activeTab">
          <v-tab-item>
            <v-card style="min-height:425px">
              <v-card-text>
                <p>This is the text that will appear in the card before the student opens the popup. This should be a short description of the item.</p>
                <v-row>
                  <v-col>
                    <v-text-field v-model="title" label="Title/Name" hide-details></v-text-field>
                    <v-textarea v-model="subtitle" label="Sub-text" rows="2" hide-details></v-textarea>
                  </v-col>
                  <v-col>
                    <h4 style="font-style:italic">Activator Preview</h4>
                    <v-list elevation="2">
                      <v-list-item>
                        <v-list-item-content>
                          <v-list-item-title>{{ title }}</v-list-item-title>
                          <v-list-item-subtitle style="white-space:normal">{{ subtitle }}</v-list-item-subtitle>
                        </v-list-item-content>
                      </v-list-item>
                    </v-list>
                  </v-col>
                </v-row>
                <h4 style="margin-top:1em">Additional Text</h4>
                <p style="margin-bottom:.1em">These are additional lines of text that will appear based on the state of the item.</p>
                <v-row>
                  <v-col>
                    <v-text-field v-model="extraText.notViewed" label="Item has not yet been viewed" hide-details></v-text-field>
                  </v-col>
                  <v-col>
                    <v-text-field v-model="extraText.viewed" label="Item has been viewed" hide-details></v-text-field>
                  </v-col>
                </v-row>
                <v-row v-if="activatable">
                  <v-col>
                    <v-text-field v-model="extraText.activated" label="Item has been activated" hide-details></v-text-field>
                  </v-col>
                  <v-col>
                    <v-text-field v-model="extraText.deactivated" label="Item has been deactivated" hide-details></v-text-field>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-tab-item>
          <v-tab-item>
            <html-editor v-model="text" style="min-height:425px"></html-editor>
          </v-tab-item>
          <v-tab-item>
            <v-card style="min-height:425px">
              <v-card-text>
                <p>The following are links that will appear at the bottom of the card. Leave blank to not show the link.</p>
                <v-row>
                  <v-col v-if="activatable">
                    <v-text-field v-model="actions.label" label="Label for activate/deactivate radio"></v-text-field>
                    <v-text-field v-model="actions.activate" label="Activate Action Text"></v-text-field>
                    <v-text-field v-model="actions.deactivate" label="Deactivate Action Text"></v-text-field>
                  </v-col>
                  <v-col>
                    <v-text-field v-model="actions.contact" label="Contact Email" hint='Leave blank for none; will show as "Contact Us"' persistent-hint></v-text-field>
                    <v-text-field v-model="actions.link" label="More Info Link" hint='Leave blank for none; will show as "More Info"' persistent-hint></v-text-field>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-tab-item>
        </v-tabs-items>
      </v-card-text>
      <v-card-actions>
        <v-btn text color="error" @click="$emit('removeItem')">Remove Popup Item</v-btn>
      </v-card-actions>
    </v-card>
  </v-tab-item>
</template>
<script>
import { ref, watch } from '@vue/composition-api'
export default {
  props: {
    activatable: {
      type: Boolean,
      default: false
    },
    item: {
      type: Object,
      required: true
    }
  },
  components: {
    HtmlEditor: () => import('@/components/forms/HTMLEditor')
  },
  setup (props, { emit }) {
    const activeTab = ref(0)

    const title = ref(props.item.title || '')
    const subtitle = ref(props.item.subtitle || '')
    const extraText = ref(props.item.extraText || {
      viewed: '',
      notViewed: 'Item has not been viewed',
      activated: 'Item as been activated',
      deactivated: 'Item has not been activated'
    })

    const text = ref(props.item.text || '')

    const actions = ref(props.item.actions || {
      label: 'Response',
      activate: 'Activate',
      deactivate: 'Deactivate',
      link: '',
      contact: ''
    })

    watch(title, () => title.value !== props.item.title ? emit('update', { title: title.value }) : '')
    watch(subtitle, () => subtitle.value !== props.item.subtitle ? emit('update', { subtitle: subtitle.value }) : '')
    watch(text, () => text.value !== props.item.text ? emit('update', { text: text.value }) : '')
    watch(extraText, () => JSON.stringify(extraText.value) !== JSON.stringify(props.item.extraText) ? emit('update', { extraText: extraText.value }) : '')
    watch(actions, () => JSON.stringify(actions.value) !== JSON.stringify(props.item.actions) ? emit('update', { actions: actions.value }) : '')

    watch(() => props.item, () => {
      if (props.item.title !== title.value) title.value = props.item.title
      if ('subtitle' in props.item && props.item.subtitle !== title.value) title.value = props.item.title
      if (props.item.text !== text.value) text.value = props.item.text
      if (JSON.stringify(extraText.value) !== JSON.stringify(props.item.extraText)) {
        for (let l in props.item.extraText) {
          extraText.value[l] = props.item.extraText[l]
        }
      }
      if (JSON.stringify(actions.value) !== JSON.stringify(props.item.actions)) {
        for (let l in props.item.actions) {
          actions.value[l] = props.item.actions[l]
        }
      }
    })

    return {
      title,
      subtitle,
      text,
      extraText,
      actions,
      activeTab
    }
  }
}
</script>
